import { render, staticRenderFns } from "./SystemBank.vue?vue&type=template&id=72d5455c&scoped=true"
import script from "./SystemBank.vue?vue&type=script&lang=js"
export * from "./SystemBank.vue?vue&type=script&lang=js"
import style0 from "./SystemBank.vue?vue&type=style&index=0&id=72d5455c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d5455c",
  null
  
)

export default component.exports